document.addEventListener("DOMContentLoaded", () => {
	var requestQuoteButton = document.querySelector(".request-quote");
	var requestQuoteDetails = document.getElementById("offerte-aanvragen");

	if (requestQuoteButton !== null && requestQuoteDetails !== null) {
		requestQuoteButton.addEventListener("click", function() {
			requestQuoteDetails.setAttribute("open", "true");
		});
	}
});